import { createFileRoute, Outlet } from "@tanstack/react-router"

export const Route = createFileRoute("/scan/$tagCode")({
  component: RouteComponent,
})

function RouteComponent() {
  return <Outlet />
}
